import React, { FC } from 'react';

import { IIconType } from './types';

export const IconArrowRight: FC<IIconType> = ({ size = 24, color = 'black' }) => {
    return (
        // <svg
        //     width={size}
        //     height={size}
        //     viewBox="0 0 24 24"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg">
        //     <path
        //         d="M3 12H21"
        //         stroke={color}
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //     />
        //     <path
        //         d="M16 7L21 12L16 17"
        //         stroke={color}
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //     />
        // </svg>
        <svg
            // width="9"
            // height="17"
            width={size}
            height={size}
            viewBox="0 0 9 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 1.5L8 8.5L1 15.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
